<div class="container">
  <mat-toolbar>
    <span>
      <h3>New User Setting</h3>
    </span>
  </mat-toolbar>
  <mat-card>
    <mat-card-content>
      <form
        name="newUserPropertiesForm"
        [formGroup]="form"
        class="example-form"
        (ngSubmit)="addUserProperties(form.value)">
        <div class="wrapper">
          <label class="label">Module </label>
          <mat-form-field>
            <input
              matInput
              name="modulename"
              formControlName="modulename"
              [formGroup]="form"
              required />
          </mat-form-field>
        </div>

        <div class="wrapper">
          <label class="label"> Setting </label>
          <mat-form-field>
            <input
              matInput
              name="property"
              formControlName="property"
              [formGroup]="form"
              required />
          </mat-form-field>
        </div>

        <div class="wrapper">
          <label class="label"> Value </label>
          <mat-form-field>
            <input
              matInput
              name="propertyvalue"
              formControlName="propertyvalue"
              [formGroup]="form"
              required />
          </mat-form-field>
        </div>

        <mat-card-actions class="buttonspace">
          <button
            type="submit"
            mat-raised-button
            mat-button
            color="primary"
            [disabled]="!form.valid || form.pristine"
            class="example-btn-width">
            Create
          </button>
          <button
            mat-raised-button
            mat-button
            color="primary"
            type="reset"
            (click)="clear()">
            Reset
          </button>
        </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>
